import { IAlbum } from "../../common/Album";

const album: IAlbum = {
  title: "Musical Plebiscite",
  date: new Date(2024, 6, 14),
  img: "/img/flute-grass.jpeg",
  video: "/videos/flute-grass.mp4",
  tracks: [
    {
      title: "Happiness is a Warm Gun",
      src: "/songs/2024-07-14/happiness-is-a-warm-gun.mp3",
      duration: 520.608,
    },
    {
      title: "Only the Willing Survive",
      src: "/songs/2024-07-14/only_the_willing_survive.mp3",
      duration: 610.944,
    },
    {
      title: "Mandalorian Funk",
      src: "/songs/2024-07-14/mandalorian_funk.mp3",
      duration: 619.2,
    },
    {
      title: "The Grassy Knoll",
      src: "/songs/2024-07-14/the_grassy_knoll.mp3",
      duration: 442.92,
    },
    {
      title: "Melted Breeze",
      src: "/songs/2024-07-14/melted_breeze.mp3",
      duration: 694.32,
    },
    {
      title: "Faded Genes",
      src: "/songs/2024-07-14/faded_genes.mp3",
      duration: 857.424,
    },
    {
      title: "Girating Mangos",
      src: "/songs/2024-07-14/girating_mangos.mp3",
      duration: 233.304,
    },
    {
      title: "Elephant Talk",
      src: "/songs/2024-07-14/elephant_talk.mp3",
      duration: 344.688,
    },
    {
      title: "Babysham",
      src: "/songs/2024-07-14/babysham.mp3",
      duration: 717.792,
    },
    {
      title: "A Taste of It All",
      src: "/songs/2024-07-14/a_taste_of_it_all.mp3",
      duration: 1023.264,
    },
    {
      title: "Dynastic Surgery",
      src: "/songs/2024-07-14/dynastic_surgery.mp3",
      duration: 677.688,
    },
    {
      title: "Skibbiddy Ska",
      src: "/songs/2024-07-14/skibbiddy_ska.mp3",
      duration: 850.8,
    },
    {
      title: "Slow Me Down",
      src: "/songs/2024-07-14/slow_me_down.mp3",
      duration: 607.32,
    },
  ],
};
export default album;
